"use client"

import { useEffect, useRef } from "react"
import { useRouter } from "next/navigation"
import { authClient } from "@/lib/auth/client"

// A cold-load session probe may restore expired cookies after the server has
// already rendered a locked page. Reconcile that page once with the new cookie.
export function QuestionAccessSync({ serverSignedIn }: { serverSignedIn: boolean }) {
  const router = useRouter()
  const refreshed = useRef(false)

  useEffect(() => {
    if (serverSignedIn || refreshed.current) return
    let mounted = true
    const {
      data: { subscription },
    } = authClient.auth.onAuthStateChange((event, session) => {
      if (!mounted || refreshed.current || !session) return
      if (event !== "INITIAL_SESSION" && event !== "SIGNED_IN" && event !== "TOKEN_REFRESHED")
        return
      // Set the guard before refresh: an immediate initial callback or repeated
      // token event must never create a refresh loop.
      refreshed.current = true
      router.refresh()
    })
    return () => {
      mounted = false
      subscription.unsubscribe()
    }
  }, [router, serverSignedIn])

  return null
}
